import { render, staticRenderFns } from "./ValueCard.vue?vue&type=template&id=02babd6e"
import script from "./ValueCard.vue?vue&type=script&lang=js"
export * from "./ValueCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
